"use client";

import { Carousel, CarouselSlide } from "@mantine/carousel";
import Link from "next/link";
import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import BlogSliderCard from "../blogs/BlogSliderCard";
export default function BlogsSlider() {
  const [blogs, setBlogs] = useState([]);
  useEffect(() => {
    async function fetchBlogs() {
      try {
        const res = await fetch(`/api/blogs/all-blogs?page=1`);
        const data = await res.json();
        const blogsData = data.blogs;
        setBlogs(blogsData?.data || []);
      } catch (err) {
        console.log(err);
      }
    }
    fetchBlogs();
  }, []);
  if (!blogs?.length) return null;
  return <section className={'blog-slider bg-gray-50 py-2 lg:py-3'}>
            <div className="max-w-7xl mx-auto px-2">
                <h2 className={'text-xl lg:text-2xl'}>{'Latest Blogs & Guide  - Everything you need to know'}</h2>
                <Carousel withIndicators={false} slideGap={'md'} previousControlProps={{
        'aria-label': 'Previous'
      }} nextControlProps={{
        'aria-label': 'Next'
      }} slideSize={{
        base: '100%',
        sm: '70%',
        md: '33.333%'
      }} emblaOptions={{
        loop: true,
        align: 'start',
        slidesToScroll: 2
      }} styles={{
        root: {
          display: 'flex',
          flexDirection: 'column-reverse'
        },
        controls: {
          position: 'relative',
          width: '100px',
          marginLeft: 'auto'
        },
        control: {
          pointerEvents: "all",
          background: "white",
          color: "black",
          width: "36px",
          height: "36px",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          "&[dataInactive]": {
            opacity: 0,
            cursor: "default"
          }
        }
      }}>
                    {blogs?.length > 0 && blogs?.map((blog, idx) => {
          return <CarouselSlide key={idx} my={'xs'}>
                                    <BlogSliderCard blog={blog} />
                                </CarouselSlide>;
        })}
                </Carousel>
                <div className="viewall">
                    <Link href={'/blogs'} className={'font-heading flex items-center gap-2'}>
                        View All
                        <Icon icon={'mdi:arrow-right'} />
                    </Link>
                </div>
            </div>
        </section>;
}